import { atom, atomFamily, selectorFamily } from 'recoil/dist'
import { User } from '../models/User'
import { Indexed } from '../models/utils/Indexed'

export class UserRepository {
  allUsers = atom<Indexed<User>>({
    key: 'user',
    default: {},
  })

  user = selectorFamily({
    key: 'user/id',
    get: (uid: string) => async ({ get }) => {
      const users = get(this.allUsers)
      return users[uid]
    },
  })

  userLikedByMe = selectorFamily({
    key: 'user/like',
    get: (uid: string) => async ({ get }) => {
      const user = get(this.user(uid))
      return user.likedByMe
    },
    set: (uid: string) => async ({ set }) => {
      set
    },
  })
}
